/* assets/label-surprise-me.js
   «Surprise me» — интенсивный резкий глитч (шаги соответствуют каждому ключевому кадру) */
;(function () {
  // CSS-инъекция
  if (!document.getElementById('surprise-glitch-style')) {
    const css = `
@keyframes surpriseGlitch {
  0%   { transform: translateY(0) scale(0.96); filter: brightness(110%) hue-rotate(0deg); }
  6%   { transform: translateY(-12px) scale(1.005) rotate(0.5deg); filter: invert(30%) hue-rotate(45deg); }
  12%  { transform: translateY(6px) scale(1.002); filter: contrast(200%) sepia(60%); }
  18%  { transform: translateY(-15px) scale(0.998) rotate(-1deg); filter: blur(2px) saturate(180%); }
  24%  { transform: translateY(10px) scale(1.006); filter: brightness(150%) hue-rotate(-20deg); }
  30%  { transform: translateY(-20px) scale(0.992); filter: blur(1px) drop-shadow(0 0 3px red); }
  36%  { transform: translateY(15px) scale(1.008); filter: hue-rotate(90deg); }
  42%  { transform: translateY(-6px) scale(1.004); filter: contrast(250%) invert(20%); }
  48%  { transform: translateY(8px) scale(0.997) rotate(0.8deg); filter: saturate(200%) hue-rotate(60deg); }
  54%  { transform: translateY(-35px) scale(1.002); filter: blur(3px); }
  60%  { transform: translateY(25px) scale(0.994); filter: brightness(180%) hue-rotate(-60deg); }
  68%  { transform: translateY(-18px) scale(1.007) rotate(-0.5deg); filter: contrast(280%) invert(40%); }
  76%  { transform: translateY(12px) scale(1.001); filter: hue-rotate(120deg) drop-shadow(0 0 2px cyan); }
  84%  { transform: translateY(-10px) scale(1.003); filter: blur(1.5px) saturate(220%); }
  92%  { transform: translateY(0px) scale(1); filter: contrast(150%) hue-rotate(-90deg); }
 100%  { transform: translateY(0px) scale(1); filter: none; }
}
#imported-Label{transform-origin:center;}
`;
    const st = document.createElement('style');
    st.id = 'surprise-glitch-style';
    st.textContent = css;
    document.head.appendChild(st);
  }

  const log = (...m) => console.log('[Surprise]', ...m);
  const err = (...m) => console.error('[Surprise]', ...m);
  const rnd = a => a[(Math.random() * a.length) | 0];
  const toC = u => {
    const m = u.match(/[?&]id=([\w-]+)/) || u.match(/\/d\/([\w-]+)/) || [];
    return m[1] ? `https://lh3.googleusercontent.com/d/${m[1]}=s800` : u;
  };
  const ready = () => window.labelsList?.length && window.labelsUrlMap;
  const waitReady = () =>
    new Promise(ok => {
      if (ready()) return ok();
      const iv = setInterval(() => {
        if (ready()) {
          clearInterval(iv);
          ok();
        }
      }, 60);
    });

  const svgCache = new Map();
  async function prefetchSvgs() {
    await waitReady();
    await Promise.all(
      window.labelsList.map(id =>
        fetch(window.labelsUrlMap[id])
          .then(r => r.text())
          .then(text => svgCache.set(id, text))
          .catch(e => err('prefetch SVG', id, e))
      )
    );
  }
  prefetchSvgs();

  function insertSvg(id) {
    const txt = svgCache.has(id)
      ? svgCache.get(id)
      : null;
    if (!txt) throw Error('SVG not in cache');
    const svg = new DOMParser()
      .parseFromString(txt, 'image/svg+xml')
      .documentElement;
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    const ph = document.getElementById('unique-PlaceForSvg');
    const host = document.getElementById('imported-Label');
    if (!ph || !host) throw Error('placeholders missing');
    host.innerHTML = '';

    const tr = ph.getAttribute('transform') || '';
    const m = /translate\(\s*([\d.-]+)[ ,]([\d.-]+)\)/.exec(tr);
    const x0 = m ? +m[1] : +ph.getAttribute('x');
    const y0 = m ? +m[2] : +ph.getAttribute('y');
    const W  = +ph.getAttribute('width');
    const H  = +ph.getAttribute('height');
    const [minX, minY, w, h] = svg
      .getAttribute('viewBox')
      .split(/\s+/)
      .map(Number);
    const k = Math.min((W * 0.85) / w, (H * 0.85) / h);

    svg.setAttribute('x', x0 + (W - w * k) / 2 - minX * k);
    svg.setAttribute('y', y0 + (H - h * k) / 2 - minY * k);
    svg.setAttribute('width',  w * k);
    svg.setAttribute('height', h * k);

    host.appendChild(svg);
    eventHub.dispatchEvent(new Event('svg-imported'));
  }

  async function randomThumb() {
    if (
      !Array.isArray(window.filteredFolders) ||
      !window.filteredFolders.length ||
      typeof window.fetchImagesFromGoogleDrive !== 'function'
    ) return null;
    const folder = rnd(window.filteredFolders);
    const files = await window.fetchImagesFromGoogleDrive(folder.id);
    return files.length ? toC(rnd(files).thumbUrl) : null;
  }

  const group = () =>
    document.getElementById('imported-Label')?.querySelector('#unique-Surface') ||
    document.getElementById('imported-Label');
  const holder = () =>
    document.getElementById('imported-Label')?.querySelector('image#ImagePlaceHolder') ||
    [...(document.getElementById('imported-Label')?.querySelectorAll('image') || [])].pop() ||
    null;

  async function surprise() {
    await waitReady();
    const id = rnd(window.labelsList);
    const g = group();
    if (g) {
      // use steps equal to number of keyframes (17) and jump at end of each step
      g.style.animation = 'surpriseGlitch 1s steps(17,end) forwards';
    }

    insertSvg(id);

    const img = holder();
    if (img) {
      const thumb = await randomThumb();
      const url = thumb || `https://drive.google.com/thumbnail?id=${id}&sz=w300`;
      img.setAttribute('href', url);
      img.setAttribute('xlink:href', url);
      window.applyPalette?.(url);
    }

    if (g) {
      g.addEventListener(
        'animationend',
        () => (g.style.animation = ''),
        { once: true }
      );
    }
  }

  document.addEventListener(
    'click',
    e => {
      const t = e.target.closest('text.st1-answer');
      if (t && /suprise\s*me/i.test(t.textContent)) surprise();
    },
    { passive: true }
  );

  log('ready');
})();
